import { render, staticRenderFns } from "./CookieSettings.vue?vue&type=template&id=465fc3f4"
import script from "./CookieSettings.vue?vue&type=script&lang=js"
export * from "./CookieSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports